import { on as t, off as s } from "./ghl-ui.es710.js";
const d = "@@mmoContext", m = {
  mounted(o, { value: e }) {
    o[d] = {
      handler: void 0
    }, typeof e == "function" && (o[d].handler = e, t("mousemoveoutside", o, e));
  },
  updated(o, { value: e }) {
    const n = o[d];
    typeof e == "function" ? n.handler ? n.handler !== e && (s("mousemoveoutside", o, n.handler), n.handler = e, t("mousemoveoutside", o, e)) : (o[d].handler = e, t("mousemoveoutside", o, e)) : n.handler && (s("mousemoveoutside", o, n.handler), n.handler = void 0);
  },
  unmounted(o) {
    const { handler: e } = o[d];
    e && s("mousemoveoutside", o, e), o[d].handler = void 0;
  }
}, u = m;
export {
  u as default
};
